import React from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function SportsDetails({ card, onClose }) {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
      <div className="relative bg-white p-8 rounded-lg shadow-lg max-w-5xl w-full">
        {/* Close Button */}
        <button
          type="button"
          onClick={onClose}
          className="absolute top-1 right-2 text-4xl text-gray-500 hover:text-red-600"
        >
          <IoIosCloseCircleOutline />
        </button>

        {/* Content Section */}
        <div className="flex flex-row space-x-6">
          {/* Text Content */}
          <div className="w-2/3">
            <h2 className="text-4xl font-bold text-gray-800 mb-6 font-titillium">
              {card.sport_activity}
            </h2>
            <p
              className="text-gray-600 leading-relaxed text-justify overflow-y-auto font-inter"
              style={{ maxHeight: "200px" }} // Adjust the height as needed
            >
              {card.description}
            </p>

            {/* Subsections */}
            <div className="mt-6 grid grid-cols-2 gap-4">
              {/* Master/Mistress in Charge */}
              <div>
                {/* <h3 className="text-lg font-semibold text-primary-color mb-2">
                  Achivements
                </h3> */}
                {/* <ul className="list-disc list-inside text-gray-600">
                  <li>Achivement 1</li>
                  <li>Achivement 2</li>
                </ul> */}
              </div>
            </div>
          </div>
          <div className="w-1/2 flex justify-end">
            <div className="w-full">
              {card.files.length > 1 ? (
                <Slider {...sliderSettings}>
                  {card.files.map((files, index) => (
                    <div key={index} className="w-full">
                      <img
                        src={files}
                        alt={card.title}
                        className="w-full h-[300px] object-contain rounded-lg"
                      />
                    </div>
                  ))}
                </Slider>
              ) : (
                <img
                  src={card.files[0]}
                  alt={card.title}
                  className="w-full h-[300px] object-contain rounded-lg"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SportsDetails;
